export type BoardTheme = {
    id: string
    name: string
    tagline: string
    white: string
    black: string
    light: string
    dark: string
    accent: string
}

export const BOARD_THEMES: BoardTheme[] = [
    {
        id: 'synthwave',
        name: 'Synthwave',
        tagline: "Cyan against magenta on a midnight grid. The classic Neon Gambit look.",
        white: '#2ef2ff',
        black: '#ff3dce',
        light: '#3a405a',
        dark: '#1a1b2d',
        accent: '#9b6bff'
    },
    {
        id: 'acid-rain',
        name: 'Acid Rain',
        tagline: "Toxic lime against ultraviolet. Loud, sharp and impossible to misread.",
        white: '#b6ff3b',
        black: '#b388ff',
        light: '#33483f',
        dark: '#151f1a',
        accent: '#3dffa8'
    },
    {
        id: 'arcade',
        name: 'Arcade',
        tagline: "Amber and electric blue, straight out of a cabinet from 1983.",
        white: '#ffb547',
        black: '#3d9bff',
        light: '#4a4034',
        dark: '#1f1913',
        accent: '#ff6b3d'
    },
    {
        id: 'red-laser',
        name: 'Red Laser',
        tagline: "Ice white and laser red. Minimal, cold and very focused.",
        white: '#e9f1ff',
        black: '#ff3355',
        light: '#423b4b',
        dark: '#1a1520',
        accent: '#7df9ff'
    }
]

export const DEFAULT_BOARD_THEME_ID = 'synthwave'
